import React from "react";
import { Breadcrumbs, Typography, Link, Box } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { pages as allPages } from "../../../pages"; // Import your full page configuration

const findPathChain = (pages, targetPath) => {
  const path = [];

  const findChainRecursively = (currentPages, currentPath) => {
    for (const page of currentPages) {
      const isMatch = page?.path === currentPath;

      if (isMatch) {
        path.push(page);
        return true;
      }

      if (page?.subPages && page.subPages.length > 0) {
        if (findChainRecursively(page.subPages, currentPath)) {
          path.unshift(page);
          return true;
        }
      }
    }
    return false;
  };

  findChainRecursively(pages, targetPath);

  const uniquePath = path.filter(
    (page, index, self) =>
      index === self.findIndex((p) => p.path === page.path),
  );

  return uniquePath;
};

const BreadcrumbsComponent = ({ currentPage, setPage }) => {
  if (!currentPage || currentPage === "dashboard") {
    return null;
  }

  const pathChain = findPathChain(allPages, currentPage);

  if (
    pathChain.length === 0 ||
    pathChain[pathChain.length - 1].path !== currentPage
  ) {
    return null;
  }

  return (
    <Box sx={{ mb: 3, ml: 3 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Link
          underline="hover"
          color="inherit"
          onClick={() => setPage("dashboard")}
          sx={{ cursor: "pointer", color: "#0772B3" }}
        >
          Home
        </Link>
        {pathChain.map((page, index) => {
          const isLast = index === pathChain.length - 1;

          if (isLast) {
            return (
              <Typography
                key={page.path}
                color="text.primary"
                sx={{ fontWeight: "bold" }}
              >
                {page.title}
              </Typography>
            );
          }

          return (
            <Link
              key={page.path}
              underline="hover"
              color="inherit"
              onClick={() => setPage(page.path)}
              sx={{ cursor: "pointer", color: "#0772B3" }}
            >
              {page.title}
            </Link>
          );
        })}
      </Breadcrumbs>
    </Box>
  );
};

export default BreadcrumbsComponent;
